"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "laces": {
    "fd48338b": [{
      "hkey": "3c90b9bd",
      "slug": "laces",
      "name": "Laces",
      "primary": true,
      "skipSearch": false
    }],
    "laces-san-martino-al-monte": [{
      "hkey": "3c90b9bd",
      "slug": "laces",
      "name": "Laces",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69a0e619": [{
      "hkey": "cb4ebc1b",
      "slug": "tarres",
      "name": "Tarres",
      "primary": true,
      "skipSearch": false
    }],
    "tarres-skicenter-malga-di-tarres": [{
      "hkey": "cb4ebc1b",
      "slug": "tarres",
      "name": "Tarres",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;